import { createSlice } from '@reduxjs/toolkit'

import type { RootState } from '../store'
import { getCustomService } from '../../helpers'
import { MessagesParams } from '../../rest/requests/messages/addMessage'

//
// requests
//

export const addMessageService = getCustomService<
  'addMessage',
  boolean,
  MessagesParams
>('addMessage')

//
// Initial state
//

export type MessageState = {
  // requests
  addMessage: typeof addMessageService.state
}

const initialState: MessageState = {
  // requests
  addMessage: addMessageService.state,
}

//
// Slice (Actions & Reducers)
//

const slice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    ...addMessageService.reducers,
  },
})

export const { reducer, actions } = slice

//
// Selectors
//

const root = (state: RootState) => state[slice.name]
const addMessage = (state: RootState) => root(state).addMessage

export const selectors = {
  addMessage,
}
